import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { config } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class ForexDerivativesService {
  config = config;
  options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };

  constructor(
    private http: HttpClient
  ) { }

  uploadFsBulkFile(file: File) {
    let URL = environment.URL + this.config.URL.uploadFsBulkFile;
    let fileOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      })
    };
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(URL, formData, fileOptions);
  }

//MarginModel
submitMarginModelDetails(requestObject: any) {
  let URL = environment.URL + this.config.URL.submitMarginModelDetails;
  this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
  return this.http.post(URL, requestObject, this.options);
}

  getInterbankTrades(requestObject: any) {
    let URL = environment.URL + this.config.URL.getInterbankTrades;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  submitCurrencyRate(requestObject: any) {
    let URL = environment.URL + this.config.URL.submitCurrencyRate;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }
  getCurrencyRate() {
    let URL = environment.URL + this.config.URL.getCurrencyRate;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  } 
  getCurrencyRateById(id: any) {
    let URL = environment.URL + this.config.URL.getCurrencyRateById+"/"+id;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getInterbankDropDownData() {
    let URL = environment.URL + this.config.URL.getInterbankDropDownData;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getClientDropDownData() {
    let URL = environment.URL + this.config.URL.getClientDropDownData;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getCurrencyCodes() {
    let URL = environment.URL + this.config.URL.getCurrencyCodes;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getClients(leiCode: String) {
    let URL = environment.URL + this.config.URL.getClients + "?userId=" + leiCode;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getClientTradesDeals(requestObject) {
    let URL = environment.URL + this.config.URL.getClientTradesDeals;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  getCounterPartyList() {
    let URL = environment.URL + this.config.URL.getCounterPartyList;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  submitForwardSwaps(requestObject) {
    let URL = environment.URL + this.config.URL.submitForwardSwaps;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  checkerActionClient(requestObject) {
    let URL = environment.URL + this.config.URL.checkerActionClient;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  uploadIntBankBulkFile(file: File) {
    let URL = environment.URL + this.config.URL.uploadIntBankBulkFile;
    let fileOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      })
    };
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(URL, formData, fileOptions);
  }

  submitTradesInterbank(fileType) {
    let URL = environment.URL + this.config.URL.submitTradesInterbank + "?fileType=" + fileType;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, null, this.options);
  }

  getCounterPartyListInterbank() {
    let URL = environment.URL + this.config.URL.getCounterPartyListInterbank;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  fetchMemberCollateral() {
    let URL = environment.URL + this.config.URL.fetchMemberCollateralDetails;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  cancelInterbankUpload(fileType) {
    let URL = environment.URL + this.config.URL.cancelTradesInterbank + "?fileType=" + fileType;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, null, this.options);
  }

  checkerActionInterbank(requestObject) {
    let URL = environment.URL + this.config.URL.checkerActionInterbank;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  getStatsData() {
    let URL = environment.URL + this.config.URL.getStatsData;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getLEIMaster() {
    let URL = environment.URL + this.config.URL.getLEIMaster;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }


}
